import React from 'react'

export default props => (
    <svg
        {...props}
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70.01 67.26"
    >
        <path
            d="M960.34,529.28c-.54-.85-1.11-1.67-1.59-2.55a2.89,2.89,0,0,0-3.94-1.36,2.83,2.83,0,0,0-1.14,4,19.74,19.74,0,0,0,5,6.27,1.15,1.15,0,0,1,.43,1.17c-.2,1.84-.36,3.68-.54,5.59l3.78.6,5.28.83a3.37,3.37,0,0,1,2.74,2.14q2.46,6.14,4.85,12.3a3.55,3.55,0,0,1-6.62,2.56q-1.95-4.83-3.82-9.69a1,1,0,0,0-.94-.72q-5.36-.79-10.71-1.65c-2.58-.42-4.17-2.37-4.55-5.37a32.43,32.43,0,0,1,1.62-15.07,7.84,7.84,0,0,1,3.19-4.32c3.56-2.22,6.91-.54,7.22,3.64,0,.54,0,1.08,0,1.62Z"
            transform="translate(-925.17 -506.71)"
        />
        <path
            d="M934.07,567.37h-4.88c.21-4.14,1.67-7.9,3.12-11.77-1.24-.16-1.25-1.05-1.21-2,0-.69,0-1.38,0-2.06,0-1,.39-1.42,1.4-1.42H955c1.3,0,1.63.33,1.64,1.61,0,.85,0,1.7,0,2.54a1.51,1.51,0,0,1-.39,1,.87.87,0,0,0-.33.88,24.61,24.61,0,0,0,2,7.38.75.75,0,0,0,.83.5h17.56v3.39H953.61a9.86,9.86,0,0,0-3-9.11,9.53,9.53,0,0,0-7.4-2.66A10,10,0,0,0,934.07,567.37Z"
            transform="translate(-925.17 -506.71)"
        />
        <path
            d="M977.56,565.47A8.5,8.5,0,1,1,986,574,8.5,8.5,0,0,1,977.56,565.47Zm11.83,0a3.31,3.31,0,0,0-3.36-3.34,3.34,3.34,0,1,0,0,6.67A3.3,3.3,0,0,0,989.39,565.48Z"
            transform="translate(-925.17 -506.71)"
        />
        <path
            d="M952.32,565.47a8.48,8.48,0,1,1-8.51-8.48A8.49,8.49,0,0,1,952.32,565.47Zm-8.45,3.34a3.34,3.34,0,1,0-3.38-3.33A3.35,3.35,0,0,0,943.87,568.81Z"
            transform="translate(-925.17 -506.71)"
        />
        <path
            d="M968.42,513c-.82.14-1.61.23-2.38.43a9.37,9.37,0,0,0-1.91.72,1.74,1.74,0,0,0-1,2l.3,2.1a6.34,6.34,0,0,1,.07.75c0,1-.16,1.34-1.18,1.49a10.09,10.09,0,0,1-6-.83c-1.67-.83-2.2-2.43-2.52-4.11a7.41,7.41,0,0,1,14.44-3.27C968.34,512.5,968.37,512.75,968.42,513Z"
            transform="translate(-925.17 -506.71)"
        />
        <path
            d="M972.32,540.06c-.94.35-1.78.68-2.65,1a1.34,1.34,0,0,1-1.94-1.13h3.45a2.79,2.79,0,0,0,2.27-.94,12.09,12.09,0,0,0,.91-1.56,6.76,6.76,0,0,1,.29.67c.61,1.77,1.21,3.55,1.83,5.31a1.17,1.17,0,0,0,.53.64,13.38,13.38,0,0,1,7.5,8.36c.07.19.15.38.29.38a46.76,46.76,0,0,1,4.58,1,10.14,10.14,0,0,1,5.51,4.7,1.43,1.43,0,0,1,.29.68,1.28,1.28,0,0,1-.3.85c-.32.27-.55,0-.76-.3a9.95,9.95,0,0,0-14.82-1.52l-.57.51C976.58,552.49,974.46,546.31,972.32,540.06Z"
            transform="translate(-925.17 -506.71)"
        />
        <path
            d="M969.94,539.37c-7.21-.45-12.31-4.09-15.75-10.26a2.26,2.26,0,0,1,.08-2.53,2.18,2.18,0,0,1,2.22-.93,2.35,2.35,0,0,1,1.76,1.37,14.72,14.72,0,0,0,7.32,6.84,13.08,13.08,0,0,0,5.58.9,2.28,2.28,0,0,1,2.43,2.85,2.16,2.16,0,0,1-1.88,1.66C971.11,539.34,970.52,539.34,969.94,539.37Z"
            transform="translate(-925.17 -506.71)"
        />
        <path
            d="M983.61,539c-.25,1.17-.41,2.25-.74,3.28s-.9,1.24-1.93,1.08a4.35,4.35,0,0,1,.29-8.63,1.35,1.35,0,0,1,1.56.94C983.13,536.77,983.35,537.91,983.61,539Z"
            transform="translate(-925.17 -506.71)"
        />
        <path
            d="M957.22,520.8a39.21,39.21,0,0,0,4.49.31c2.13-.08,2.54-.61,2.36-2.82-.06-.72-.19-1.44-.32-2.16a1.26,1.26,0,0,1,.77-1.52,26.67,26.67,0,0,1,2.94-.83c.13,0,.4.24.48.42a6.39,6.39,0,0,1-4.88,8.73A6.18,6.18,0,0,1,957.22,520.8Z"
            transform="translate(-925.17 -506.71)"
        />
        <path
            d="M944.42,527.86H927c-1.25,0-1.81.54-1.81,1.79q0,8.58,0,17.16c0,1.25.55,1.8,1.79,1.8H944.4c1.25,0,1.82-.56,1.82-1.79q0-8.58,0-17.16A1.57,1.57,0,0,0,944.42,527.86ZM942,542.48H932a1,1,0,0,1,0-2H942a1,1,0,0,1,0,2Zm0-4.06h-7.69a1,1,0,0,1,0-2H942a1,1,0,1,1,0,2Zm0-4.06h-4a1,1,0,0,1,0-2h4a1,1,0,1,1,0,2Z"
            transform="translate(-925.17 -506.71)"
        />
    </svg>
)
